import { t } from '../i18n';

/** Browser → object storage. The API only signs the URL (owner rule: it never receives files). */

/** PUT a file to a presigned upload ({url, headers}). onProgress gets 0-100. */
export const putToStorage = (upload, file, onProgress) => new Promise((resolve, reject) => {
    const fail = () => reject({ status: 'error', msg: t('The upload failed. Try again') }); // eslint-disable-line prefer-promise-reject-errors
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', upload.url);
    Object.entries(upload.headers || {}).forEach(([k, v]) => xhr.setRequestHeader(k, v));
    if (onProgress) xhr.upload.onprogress = (ev) => { if (ev.lengthComputable) onProgress(Math.round((ev.loaded / ev.total) * 100)); };
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : fail());
    xhr.onerror = fail;
    xhr.onabort = fail;
    xhr.send(file);
});

/**
 * Upload antd files one by one and return their keys. Throws the API's or the upload's error.
 * @param {Function} requestUrl ({name, size}) → API response whose data is {url, key, headers}
 * @param {Function} onChange (uid, {status, percent}) for the file list's progress display
 */
export const uploadFiles = async (files, requestUrl, onChange) => {
    const keys = [];
    for (const f of files || []) {
        const raw = f.originFileObj || f;
        const report = (patch) => onChange && onChange(f.uid, patch);
        report({ status: 'uploading', percent: 0 });
        try {
            // eslint-disable-next-line no-await-in-loop
            const r = await requestUrl({ name: raw.name, size: raw.size });
            if (r?.status !== 'success') throw r;
            // eslint-disable-next-line no-await-in-loop
            await putToStorage(r.data, raw, (percent) => report({ status: 'uploading', percent }));
            keys.push(r.data.key);
            report({ status: 'done', percent: 100 });
        } catch (e) {
            report({ status: 'error', percent: 0 });
            throw e;
        }
    }
    return keys;
};

/** Apply an uploadFiles progress report to an antd file list. */
export const patchFile = (list, uid, patch) => (list || []).map((f) => (f.uid === uid ? { ...f, ...patch } : f));
